import { AUTH_TOKEN_LS_KEY, UserProfile } from "@tt-app/models";
import { VUEX_USER_MUTATION_NAMES } from "@tt-app/constants/user";
import { Alias, UserState } from "./types";

const {
  ALIASES,
  COURSE_HISTORY,
  GROUPS,
  LOGIN_FAILURE,
  LOGIN_SUCCESS,
  LOGOUT,
  SELECTED_ALIAS,
  SET_PASSWORD_WITH_TMP_PASSWORD,
  SET_PASSWORD_RESET_ERROR,
  SET_USER_PROFILE,
  VALIDATE_TMP_PASSWORD,
  VALIDATE_JWT_FAILURE,
  VALIDATED_JWT,
  VALIDATE_RESET_PASSWORD_JWT_FAILURE
} = VUEX_USER_MUTATION_NAMES;

const userMutations = {
  [ALIASES](state: any, aliases: any) {
    state.aliases = aliases;
  },
  [COURSE_HISTORY](state: any, { history }: any) {
    state.course.history = history;
  },
  [GROUPS](state: any, groups: any) {
    state.groups = groups;
  },
  [LOGIN_FAILURE](state: any, errorString: any) {
    state.authentication.error = errorString;
  },
  [LOGIN_SUCCESS](state: any, { token }: any) {
    state.authentication.token = token;

    if (token) {
      localStorage.setItem(AUTH_TOKEN_LS_KEY, token);
    } else {
      localStorage.removeItem(AUTH_TOKEN_LS_KEY);
    }
  },
  [LOGOUT](state: any) {
    state.aliases = [];
    state.authentication.token = null;
    state.groups = undefined;
    state.profile = undefined;
    state.selectedAlias = undefined;
    state.authentication.tmpPasswordValidated = false;

    localStorage.removeItem(AUTH_TOKEN_LS_KEY);
  },

  [SELECTED_ALIAS](state: any, payload: { alias: Alias }) {
    state.selectedAlias = payload.alias;
  },

  [SET_PASSWORD_WITH_TMP_PASSWORD](state: any, { token }: any) {
    state.authentication.token = token;

    if (token) {
      localStorage.setItem(AUTH_TOKEN_LS_KEY, token);
    } else {
      localStorage.removeItem(AUTH_TOKEN_LS_KEY);
    }
  },

  [SET_PASSWORD_RESET_ERROR](state: UserState, error: string) {
    state.pwdReset.error = error;
  },

  [SET_USER_PROFILE](state: UserState, profile?: UserProfile) {
    state.profile = profile;
  },
  [VALIDATE_TMP_PASSWORD](state: any, { email, groupNames, orgName, userName }: any) {
    state.authentication.tmpPasswordValidated = true;
    state.email = email;
    state.groupNames = groupNames;
    state.orgName = orgName;
    state.userName = userName;
  },
  [VALIDATE_JWT_FAILURE](state: any, error: string) {
    state.authentication.jwtValidationError = error;
  },
  [VALIDATED_JWT](state: any, { email, orgName, userName }: any) {
    state.email = email;
    state.orgName = orgName;
    state.userName = userName;
  },
  [VALIDATE_RESET_PASSWORD_JWT_FAILURE](state: any, error: string) {
    state.authentication.jwtValidationError = error;
  }
};

export { userMutations };
